import 'core-js/es/promise';
import 'core-js/es/array';
import 'core-js/es/string';
import 'core-js/es/object';
import 'core-js/es/number';
import 'core-js/es/symbol/iterator';
import 'core-js/stable/url-search-params';
import 'regenerator-runtime/runtime';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';

import './i18n';
import './styles/index.css';
import type RouterComponent from './Router';
import { removeStaticSeoDefaults } from './commons/seo/Seo';
import { initTheme } from './commons/theme/theme';
import type AppInstanceType from './commons/types/AppInstanceType';
import type ConfigType from './commons/types/ConfigType';

// process.env.GLITCHTIP_DSN est injecté au build (webpack.prod.js) — vide en dev, donc
// Sentry.init() se désactive silencieusement (comportement documenté du SDK).
Sentry.init({
    dsn: process.env.GLITCHTIP_DSN,
    // Version déployée (SHA du commit, injecté au build) : GlitchTip indique quelle version a
    // introduit une erreur.
    release: `foundit-frontend@${process.env.APP_VERSION}`,
    tracesSampleRate: 0.1,
    // GlitchTip ne supporte pas le tracking de sessions (recommandation officielle GlitchTip).
    autoSessionTracking: false,
});

export const App = (configuration: ConfigType): AppInstanceType => ({
    start: () => {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        const { default: Router } = require('./Router') as { default: typeof RouterComponent };
        // it is mandatory to pass
        // configuration as props to
        // Routes to get it directly
        // on props for withAppRouter
        removeStaticSeoDefaults();
        initTheme();
        const root = createRoot(configuration.container);
        root.render(
            <Sentry.ErrorBoundary fallback={<div>Une erreur est survenue.</div>}>
                <Router configuration={configuration} />
            </Sentry.ErrorBoundary>,
        );
    },

    getConfiguration: () => configuration,

    api: {
        /**
         * Ajouter ici les fonctions exposées ...
         */
    },
});
